import { Record } from 'immutable';
import BrandingRecord from './BrandingRecord';
class PresentationRecord extends Record({
  accessId: null,
  brandingMetadata: null,
  hasActivity: null,
  hasDownload: null,
  id: null,
  name: null,
  pdfUrl: null,
  portalId: null,
  sharedWithVid: null,
  shortLink: null,
  skipForm: null,
  slides: null,
  user: {},
  userId: null
}, 'PresentationRecord') {
  static create(presentation) {
    var _ref, _presentation$brandin;
    const brandingData = (_ref = (_presentation$brandin = presentation.brandingMetadataV2) !== null && _presentation$brandin !== void 0 ? _presentation$brandin : presentation.brandingMetadata) !== null && _ref !== void 0 ? _ref : {};
    return new PresentationRecord(Object.assign({}, presentation, {
      brandingMetadata: new BrandingRecord(brandingData)
    }));
  }
}
export default PresentationRecord;